export default __webpack_public_path__ + "static/media/demo.572ff7a2.webm";